<template>
	<div class='knd-story' >
		<div class='knd-bg'>
			<img 
				style="top: 10%; left: 10%;"
				class='icon-absolute' 
				src='@/assets/icons/star.svg' 
			/> 

			<img 
				style="top: 10%; right: 20%;"
				class='icon-absolute' 
				src='@/assets/icons/star-no-fill.svg' 
			/> 

			<img 
				style="bottom: 10%; left: 20%;"
				class='icon-absolute' 
				src='@/assets/icons/hexa.svg' 
			/> 

			<img 
				style="bottom: 20%; left: 50%;"
				class='icon-absolute' 
				src='@/assets/icons/hexa-no-fill.svg' 
			/> 

			<img 
				style="bottom: 10%; right: 20%;"
				class='icon-absolute' 
				src='@/assets/icons/star.svg' 
			/> 

		</div>
		<div class='knd-container'>
			<router-view v-slot="{ Component }">
				<transition name="slidedown">
					<component :is="Component" />
				</transition>
			</router-view>
		</div>
	</div>
</template>

<script>
	import '@/scss/index.scss'

	export default {
		name: 'app'
	}
</script>